import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridMinLevel';
export const DEFAULT_MIN_LEVEL = 4;

const parseMinLevel = (raw: string): number => {
	const parsedValue = Number(JSON.parse(raw));
	return Number.isNaN(parsedValue) ? DEFAULT_MIN_LEVEL : parsedValue;
};

export const useMinLevel = () => {
	const [minLevel, setMinLevel] = useLocalStorageState(STORAGE_KEY, DEFAULT_MIN_LEVEL, parseMinLevel);
	return { minLevel, setMinLevel };
};
